export const truncate = (str: string, no_words: number) => {

    if(typeof str === 'undefined' || str === null) return '';

    const words = str.split(" ");
    let newString: string;

    if(words.length > (no_words + 3)) {
        newString = words.splice(0,no_words).join(" ");
        newString = newString + "...";
    } else {
        newString = str;
    }
    return newString;
};

export const truncateFirstDot = (str: string) => {
    if(!str) return '';

    if(!str.includes('.')) return str;

    const regex = /^([^.]+)/;

    const newStrMatch = str.match(regex);

    if(newStrMatch !== null && newStrMatch.length > 1) {
        return newStrMatch[0] + '.';
    }

    return truncateLetters(str, 15);
};

export const truncateSecondDot = (str: string) => {
    if(!str) return '';

    const index = getPosition(str, '.', 2);

    return str.substring(0, index + 1);
};

const getPosition = (string: string, subString: string, index: number) => {



    return string.split(subString, index).join(subString).length;
};


export const truncateLetters = (str: string, letters: number = 85) => {
    if(!str) return '';

    let newstring: string;


    newstring = str.slice(0, letters);
    newstring = newstring.substr(0, Math.min(newstring.length, newstring.lastIndexOf(" ")));

    return newstring + ' ...';
};

export const replaceLineBreak = (str: string) => {
    if(!str) return "";
    return  str.replace(/(?:\r\n|\n)/g, '<br />');
};

export const stringContainsHtml = (content: string) => {
    if(!content) return false;
    const regex = /<\/?[A-Za-z][^>]*>/g;
    const match = content.match(regex);
    return match !== null;
};

export const getVideoId = (url: string) => {


    const regex = /(?:https?:\/\/(?:[a-z]+.)?)(?:youtu\.?be(?:\.com)?\/)(?:embed\/)?(?:(?:(?:(?:watch\?)?(?:time_continue=(?:[0-9]+))?.+v=)?([a-zA-Z0-9_-]+))(?:\?t=(?:[0-9a-zA-Z]+))?)/;

    const match = url.match(regex);

    return (match !== null) ? match[1] : '';
};

export const stringToId = (name: string) => {
    if(!name) return '';

    return name.replace(/å/g, 'a')
        .replace(/Å/g, 'a')
        .replace(/ä/g, 'a')
        .replace(/Ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/Ö/g, 'o')
        .toLowerCase();
};
